import { FiAlertTriangle, FiArrowLeftCircle, FiPrinter, FiSave, FiSearch, FiSlash } from "react-icons/fi"
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { getIncomeList, postCashOut } from "../store/thunk";
import { CashOutTotalsFormatter } from "../../../../utils/formatters/CashOutTotalsFormatter";
import { CashOutFormatter } from "../../../../utils/formatters/CashOutFormatter";
import { Loading } from "../../../../components/Loading";
import { CardSummary } from "../../shared/CardSummary";
import { Table } from "../../../../components/Table";
import { clearMemory } from "../store/slice";
import { InputValidators } from "../../../../utils/validators/InputValidators";
import { formatDecimalOnBlur } from "../../../../utils/formatters/DecimalOnBlurFormatter";



// Modulo: Nuevo Corte de Caja
export const NewCashOut = ({ onCancel }) => {

  let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes; let today = f.getFullYear() + "-" + mes + "-" + dia;

  const { isLoading, orders_totals, sales_totals, advancedPayment_totals, orders_details, sales_details, advancedPayment_details, status, dateStart, dateEnd, discounts } = useSelector(state => state.cashOut);

  const { usuario, id_emp } = useSelector(state => state.usuario);
  const { register, control, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({ model: 'all' });
  const dispatch = useDispatch();


  const searchData = (data) => {
    let fechaI = data.fechaInicial; let fechaT = data.fechaFinal;
    dispatch(getIncomeList(fechaI, fechaT));
  }

  const cancel = () => {
    window.location.reload()
  }

  // ToDo:
  let totalOrdenes = [...orders_totals];
  let totalAnticipos = [...advancedPayment_totals]
  let totalVentas = [...sales_totals];

  let total_ordenes = CashOutTotalsFormatter(totalOrdenes);
  let total_anticipos = CashOutTotalsFormatter(totalAnticipos);
  let total_ventas = CashOutTotalsFormatter(totalVentas);

  let cardTrans_total = total_ordenes.TRANS + total_ventas.TRANS + total_anticipos.TRANS;
  let cardEfectivo_total = total_ordenes.EFECTIVO + total_ventas.EFECTIVO + total_anticipos.EFECTIVO;
  let cardTDD_total = total_ordenes.TDD + total_ventas.TDD + total_anticipos.TDD;
  let cardTDC_total = total_ordenes.TDC + total_ventas.TDC + total_anticipos.TDC;

  // Ordenes
  let ordenes = [...orders_details];
  let datosOrdenes = CashOutFormatter(ordenes);
  let columnsOrdenes = [
    {
      header: 'FOLIO',
      dataIndex: 'FOLIO',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'TRANS.',
      dataIndex: 'TRANS',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'EFECTIVO',
      dataIndex: 'EFECTIVO',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'TDD',
      dataIndex: 'TDD',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'TDC',
      dataIndex: 'TDC',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
  ];

  // Ventas
  let ventas = [...sales_details];
  let datosVentas = CashOutFormatter(ventas);
  let columnsVentas = [
    {
      header: 'FOLIO',
      dataIndex: 'FOLIO',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'TRANS.',
      dataIndex: 'TRANS',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'EFECTIVO',
      dataIndex: 'EFECTIVO',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'TDD',
      dataIndex: 'TDD',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'TDC',
      dataIndex: 'TDC',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
  ];

  // Anticipos
  let anticipos = [...advancedPayment_details];
  let datosAnticipos = CashOutFormatter(anticipos);
  let columnsAnticipos = [
    {
      header: 'FOLIO',
      dataIndex: 'FOLIO',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'TRANS.',
      dataIndex: 'TRANS',
      classHeader: 'text-center',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'EFECTIVO',
      dataIndex: 'EFECTIVO',
      classHeader: 'text-center',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'TDD',
      dataIndex: 'TDD',
      classHeader: 'text-center',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'TDC',
      dataIndex: 'TDC',
      classHeader: 'text-center',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
  ];

  // Descuentos
  let datosDescuentos = [...discounts];
  let columnsDescuentos = [
    {
      header: 'FOLIO',
      dataIndex: 'FOLIO',
      classHeader: 'text-start',
      classRow: 'text-start',
    },

    {
      header: 'REAL',
      dataIndex: 'base',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: '%',
      dataIndex: 'percentage',
      classHeader: 'text-center',
      classRow: 'text-center',
      // renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'COBRADO',
      dataIndex: 'amount',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'APLICADO',
      dataIndex: 'descriptions',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
  ];



  let disabledElements = totalOrdenes.length === 0 && totalAnticipos.length === 0 && totalVentas.length === 0;

  const [declaradoTrans, setDeclaradoTrans] = useState(0);
  const [difierenciaTrans, setDifierenciaTrans] = useState(0);

  const diferenceTrans = (e) => {
    const valor = parseFloat(e.target.value) || 0;
    setDeclaradoTrans(valor);
    const nuevaDiferencia = valor - (total_ordenes.TRANS + total_ventas.TRANS + total_anticipos.TRANS);
    setDifierenciaTrans(nuevaDiferencia);
  };

  const [declaradoEfectivo, setDeclaradoEfectivo] = useState(0);
  const [difierenciaEfectivo, setDifierenciaEfectivo] = useState(0);

  const diferenceEfectivo = (e) => {
    let valor = parseFloat(e.target.value) || 0;
    setDeclaradoEfectivo(valor);
    let nuevaDiferencia = valor - (total_ordenes.EFECTIVO + total_ventas.EFECTIVO + total_anticipos.EFECTIVO);
    setDifierenciaEfectivo(nuevaDiferencia);
  };

  const [declaradoTDD, setDeclaradoTDD] = useState(0);
  const [difierenciaTDD, setDifierenciaTDD] = useState(0);

  const diferenceTDD = (e) => {
    let valor = parseFloat(e.target.value) || 0;
    setDeclaradoTDD(valor);
    let nuevaDiferencia = valor - (total_ordenes.TDD + total_ventas.TDD + total_anticipos.TDD);
    setDifierenciaTDD(nuevaDiferencia);
  };

  const [declaradoTDC, setDeclaradoTDC] = useState(0);
  const [difierenciaTDC, setDifierenciaTDC] = useState(0);

  const diferenceTDC = (e) => {
    let valor = parseFloat(e.target.value) || 0;
    setDeclaradoTDC(valor);
    let nuevaDiferencia = valor - (total_ordenes.TDC + total_ventas.TDC + total_anticipos.TDC);
    setDifierenciaTDC(nuevaDiferencia);
  };


  let diferenciaTotal = 0;
  const calculatedDiferencia = () => {
    let tot = total_ordenes.TRANS + total_ventas.TRANS + total_anticipos.TRANS + total_ordenes.EFECTIVO + total_ventas.EFECTIVO + total_anticipos.EFECTIVO + total_ordenes.TDD + total_ventas.TDD + total_anticipos.TDD + total_ordenes.TDC + total_ventas.TDC + total_anticipos.TDC;
    diferenciaTotal = Number(document.getElementById('declarado_total').value) - tot;

    // Correccion 
    diferenciaTotal = (Number(document.getElementById('declarado_total').value) - (Number(document.getElementById('total_fondo').value)).toFixed(2)) - tot;
    document.getElementById("total_diferencia").value = (diferenciaTotal).toFixed(2);
  }


  useEffect(() => {
    if (status == 'waiting') {
      document.getElementById('diferencia_trans').value = '';
      document.getElementById('diferencia_efectivo').value = '';
      document.getElementById('diferencia_tdd').value = '';
      document.getElementById('diferencia_tdc').value = '';
      document.getElementById('total_fondo').value = '';
      document.getElementById('total_diferencia').value = '';
      setDeclaradoTrans(0); setDeclaradoEfectivo(0); setDeclaradoTDD(0); setDeclaradoTDC(0);
      document.getElementById('declarado_total').value = '';
      document.getElementById('total_ingresos_acumulado').value = '';
    }
  }, [status]);

  useEffect(() => {
    dispatch(clearMemory());
    document.getElementById('diferencia_trans').value = '';
    document.getElementById('diferencia_efectivo').value = '';
    document.getElementById('diferencia_tdd').value = '';
    document.getElementById('diferencia_tdc').value = '';
    document.getElementById('total_fondo').value = '';
    document.getElementById('total_diferencia').value = '';
    setDeclaradoTrans(0); setDeclaradoEfectivo(0); setDeclaradoTDD(0); setDeclaradoTDC(0);
    document.getElementById('declarado_total').value = '';
    document.getElementById('total_ingresos_acumulado').value = '';
  }, []);


  const saveCashOut = () => {

    // console.log(declaradoEfectivo);
    // console.log(declaradoTDC);
    // console.log(declaradoTDD);
    // console.log(declaradoTrans);


    if (declaradoEfectivo == 0 || declaradoTDC == 0 || declaradoTDD == 0 || declaradoTrans == 0 || Number(document.getElementById('total_fondo').value) == 0) {
      // alert('Favor de ingresar valores declarados');
      Swal.fire({
        title: "Atención",
        text: 'Favor de declarar los totales correspondientes',
        icon: "warning",
        customClass: {
          confirmButton: 'btn btn-primary  me-2',
          // cancelButton: 'btn btn-secondary'
        },
        showCancelButton: false, // <-- ¡Este es importante!
        confirmButtonText: 'Entendido',
        // cancelButtonText: 'No',
        buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
      }).then((result) => {
        if (result.isConfirmed) {
          // Realizar peticion a thunk
          // dispatch(postCashOut(userName, branch, cashBase, expectedTotal, realTotal, difference, cashOutDetails, orders_details, sales_details, advancedPayment_details,discounts, dateStart, dateEnd));
        }
      });

      return;
    }

    const cashOutDetails = [
      {
        // Transferencias
        payment_method_id: 1,
        expected_amount: (total_ordenes.TRANS + total_ventas.TRANS + total_anticipos.TRANS).toFixed(2),
        declared_amount: (declaradoTrans).toFixed(2),
        diference: (difierenciaTrans).toFixed(2)
      },
      {
        // Efectivo
        payment_method_id: 2,
        expected_amount: (total_ordenes.EFECTIVO + total_ventas.EFECTIVO + total_anticipos.EFECTIVO).toFixed(2),
        declared_amount: (declaradoEfectivo).toFixed(2),
        diference: (difierenciaEfectivo).toFixed(2)
      },
      {
        // T. Débito
        payment_method_id: 3,
        expected_amount: (total_ordenes.TDD + total_ventas.TDD + total_anticipos.TDD).toFixed(2),
        declared_amount: (declaradoTDD).toFixed(2),
        diference: (difierenciaTDD).toFixed(2)
      },
      {
        // T. Crédito
        payment_method_id: 4,
        expected_amount: (total_ordenes.TDC + total_ventas.TDC + total_anticipos.TDC).toFixed(2),
        declared_amount: (declaradoTDC).toFixed(2),
        diference: (difierenciaTDC).toFixed(2)
      }
    ];

    let userName = usuario; let branch = '1';
    let cashBase = (Number(document.getElementById('total_fondo').value)).toFixed(2);
    let expectedTotal = (total_ordenes.TRANS + total_ventas.TRANS + total_anticipos.TRANS + total_ordenes.EFECTIVO + total_ventas.EFECTIVO + total_anticipos.EFECTIVO + total_ordenes.TDD + total_ventas.TDD + total_anticipos.TDD + total_ordenes.TDC + total_ventas.TDC + total_anticipos.TDC).toFixed(2);
    let realTotal = (Number(document.getElementById('declarado_total').value)).toFixed(2) - cashBase;
    let difference = realTotal - expectedTotal;

    Swal.fire({
      title: "Atención",
      text: 'Está por registrar un nuevo Corte de caja. ¿Desea continuar con esta acción?',
      icon: "question",
      customClass: {
        confirmButton: 'btn btn-primary  me-2',
        cancelButton: 'btn btn-secondary'
      },
      showCancelButton: true, // <-- ¡Este es importante!
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'No',
      buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
    }).then((result) => {
      if (result.isConfirmed) {
        // Realizar peticion a thunk
        dispatch(postCashOut(userName, branch, cashBase, expectedTotal, realTotal, difference, cashOutDetails, orders_details, sales_details, advancedPayment_details,discounts, dateStart, dateEnd));
      }
    });
  }


  if (isLoading) {
    return (
      <Loading />
    )
  }

  return (
    <div className="row">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <button className="btn btn-outline-dark border-0" onClick={onCancel}>
          <FiArrowLeftCircle size={23} /> <span className="ms-2">Regresar</span>
        </button>
      </div>

      <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <div className="card">
          <div className="card-header border-bottom">
            <h5 className="card-title mb-0 text-black">Filtros</h5>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(searchData)}>
              <div className="mb-3">
                <label className="form-label">Fecha Inicio:</label>
                <input type="date" className="form-control" defaultValue={today} {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                {
                  errors.fechaInicial &&
                  <div className='text-left-5 mt-2'>
                    <FiAlertTriangle size="18" color="#dc3545" />
                    <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                  </div>
                }
              </div>
              <div className="mb-3">
                <label className="form-label">Fecha Inicio:</label>
                <input type="date" className="form-control" defaultValue={today} {...register("fechaFinal", { required: 'Introduce fecha final' })} />
                {
                  errors.fechaFinal &&
                  <div className='text-left-5 mt-2'>
                    <FiAlertTriangle size="18" color="#dc3545" />
                    <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaFinal.message}</small></span>
                  </div>
                }
              </div>
              <button type="submit" className="btn btn-outline-dark w-100">Buscar</button>
            </form>
          </div>
        </div>
      </div>

      <div className="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 col-xxl-10">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <CardSummary title={'Transferencias'} value={cardTrans_total} icon={'transfer'} />
          </div>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <CardSummary title={'Efectivo'} value={cardEfectivo_total} icon={'cash'} />
          </div>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <CardSummary title={'Tarjeta de Debito'} value={cardTDD_total} icon={'debit'} />
          </div>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <CardSummary title={'Tarjeta de Credito'} value={cardTDC_total} icon={'credit'} />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <div className="card">
              <div className="card-header border-bottom">
                <h5 className="card-title mb-0 text-black">Ordenes de Servicio</h5>
              </div>
              <div className="card-body">
                <Table columns={columnsOrdenes} data={datosOrdenes} function_={[]} placeholderSearch="Buscar orden"
                  showPagination={false} showControls={false} showTotals={true} tableHeight="200px"
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <div className="card">
              <div className="card-header border-bottom">
                <h5 className="card-title mb-0 text-black">Ventas</h5>
              </div>
              <div className="card-body">
                <Table columns={columnsVentas} data={datosVentas} function_={[]} placeholderSearch="Buscar orden"
                  showPagination={false} showControls={false} tableHeight="200px" showTotals={true}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <div className="card">
              <div className="card-header border-bottom">
                <h5 className="card-title mb-0 text-black">Anticipos</h5>
              </div>
              <div className="card-body">
                <Table columns={columnsAnticipos} data={datosAnticipos} function_={[]} placeholderSearch="Buscar orden"
                  showPagination={false} showControls={false} tableHeight="200px" showTotals={true}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <div className="card">
              <div className="card-header border-bottom">
                <h5 className="card-title mb-0 text-black">Descuentos   <span className="fw-bold"><small>(No impacta el registro de ingresos)</small></span></h5>
              </div>
              <div className="card-body">
                <Table columns={columnsDescuentos} data={datosDescuentos} function_={[]} placeholderSearch="Buscar orden"
                  showPagination={false} showControls={false} tableHeight="200px" showTotals={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-2" />
          <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8">
            <div className="card">
              <div className="card-header border-bottom">
                <h5 className="card-title mb-0 text-black">RESUMEN</h5>
              </div>
              <form>
                <div className="card-body">

                  <div className='table-responsive mt-1 '>
                    <table className="table table-hover table-sm">
                      <thead>
                        <tr>
                          <th scope="col" className='text-start'>CONCEPTO</th>
                          <th scope="col" className='text-center'>TRANSFERENCIAS</th>
                          <th scope="col" className='text-center'>EFECTIVO</th>
                          <th scope="col" className='text-center'>T. DEBITO</th>
                          <th scope="col" className='text-center'>T. CREDITO</th>
                          <th scope="col" className='text-center'>ACUMULADO</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row" className='text-start'>ORDENES</th>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ordenes.TRANS)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ordenes.EFECTIVO)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ordenes.TDD)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ordenes.TDC)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(
                            total_ordenes.TRANS + total_ordenes.EFECTIVO + total_ordenes.TDD + total_ordenes.TDC
                          )} </td>
                        </tr>
                        <tr>
                          <th scope="row" className='text-start'>VENTAS</th>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ventas.TRANS)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ventas.EFECTIVO)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ventas.TDD)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ventas.TDC)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(
                            total_ventas.TRANS + total_ventas.EFECTIVO + total_ventas.TDD + total_ventas.TDC
                          )} </td>
                        </tr>
                        <tr>
                          <th scope="row" className='text-start'>ANTICIPOS</th>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_anticipos.TRANS)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_anticipos.EFECTIVO)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_anticipos.TDD)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_anticipos.TDC)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(
                            total_anticipos.TRANS + total_anticipos.EFECTIVO + total_anticipos.TDD + total_anticipos.TDC
                          )} </td>
                        </tr>

                        <tr>
                          <th scope="row" className='text-start'>TOTALES:</th>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ordenes.TRANS + total_ventas.TRANS + total_anticipos.TRANS)}</td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ordenes.EFECTIVO + total_ventas.EFECTIVO + total_anticipos.EFECTIVO)} </td>
                          <td className='text-center'>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ordenes.TDD + total_ventas.TDD + total_anticipos.TDD)}  </td>
                          <td className='text-center'> {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(total_ordenes.TDC + total_ventas.TDC + total_anticipos.TDC)} </td>
                          <td className='text-center'>
                            <input type='text' className='form-control text-end' value={(total_ordenes.TRANS + total_ventas.TRANS + total_anticipos.TRANS + total_ordenes.EFECTIVO + total_ventas.EFECTIVO + total_anticipos.EFECTIVO + total_ordenes.TDD + total_ventas.TDD + total_anticipos.TDD + total_ordenes.TDC + total_ventas.TDC + total_anticipos.TDC).toFixed(2)}
                              id='total_ingresos_acumulado' disabled style={{ width: '100px' }} />
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" className='text-end'>DECLARADO:</th>
                          <td className='text-end'> <input type='text' id='declarado_trans' disabled={disabledElements} autoComplete="off" onChange={diferenceTrans} onKeyDown={InputValidators.validateDecimalKeyDown} onBlur={formatDecimalOnBlur} className='form-control text-end' style={{ width: '100px' }} /></td>
                          <td className='text-end'> <input type='text' id='declarado_efectivo' disabled={disabledElements} autoComplete="off" onChange={diferenceEfectivo} onKeyDown={InputValidators.importeKeyDown} onBlur={formatDecimalOnBlur} className='form-control text-end' style={{ width: '100px' }} /></td>
                          <td className='text-end'> <input type='text' id='declarado_tdd' disabled={disabledElements} autoComplete="off" onChange={diferenceTDD} onKeyDown={InputValidators.importeKeyDown} onBlur={formatDecimalOnBlur} className='form-control text-end' style={{ width: '100px' }} /></td>
                          <td className='text-end'> <input type='text' id='declarado_tdc' disabled={disabledElements} autoComplete="off" onChange={diferenceTDC} onKeyDown={InputValidators.importeKeyDown} onBlur={formatDecimalOnBlur} className='form-control text-end' style={{ width: '100px' }} /></td>
                          <td className='text-end'>
                            <input type='text' className='form-control text-end' id='declarado_total' value={declaradoTrans + declaradoEfectivo + declaradoTDD + declaradoTDC} disabled style={{ width: '100px' }} />
                          </td>
                        </tr>
                        <tr>
                          <td className='text-end fw-bold'> </td>
                          <td className='text-center'>
                            <input type='text' className='form-control text-end' disabled={disabledElements} readOnly id='diferencia_trans' value={difierenciaTrans.toFixed(2)} style={{ width: '100px', display: 'none' }} />
                          </td>
                          <td>
                            <input type='text' className='form-control text-end' disabled={disabledElements} readOnly id='diferencia_efectivo' value={difierenciaEfectivo.toFixed(2)} style={{ width: '100px', display: 'none' }} />
                          </td>
                          <td>
                            <input type='text' className='form-control text-end' disabled={disabledElements} readOnly id='diferencia_tdd' value={difierenciaTDD.toFixed(2)} style={{ width: '100px', display: 'none' }} />
                          </td>
                          <td className='text-end fw-bold'>
                            <input type='text' className='form-control text-end' disabled={disabledElements} readOnly id='diferencia_tdc' value={difierenciaTDC.toFixed(2)} style={{ width: '100px', display: 'none' }} />
                            FONDO:
                          </td>
                          <td>
                            <input type='text' className='form-control text-end' disabled={disabledElements} autoComplete="off" id='total_fondo' onChange={calculatedDiferencia} style={{ width: '100px', }} />
                          </td>
                        </tr>
                        <tr>

                          <td colSpan={5} className='text-end fw-bold'></td>
                          <td className='text-end'>
                            <input type='text' className='form-control text-end ' id='total_diferencia' disabled style={{ width: '100px', display: 'none' }} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="text-end mt-3">
                    <button type="button" className="btn btn-outline-danger me-2" onClick={cancel}> <FiSlash size={22} /> Cancelar</button>
                    <button type="button" className="btn btn-outline-primary" disabled={disabledElements} onClick={saveCashOut} > <FiSave size={22} /> Guardar</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-2" />
        </div>

      </div>

    </div>
  )
}
